<template lang="pug">
.category-posts.container(v-if="section.categories")
    .subfilter.container(v-if="showFilter && categoryFilters && categoryFilters.length")
        Select.custom-select(
            v-for="filter in categoryFilters"
            :filter="filter"
            v-on:changedFilter="updateCategoryFilter"
            :key="filter.id"
        )

        //- select.input(v-for="filter in categoryFilters" type="select", :placeholder="filter.name" v-model="selected")
        //-     option(v-for="option in filter.pages" :value="option.pivot.value") {{ option.pivot.value}}
    .horizontal(v-if="orientation === 'horizontal'" ref="teasers")
        loading(
            :active="loading",
            :is-full-page="false",
            :height="40",
            :width="40",
            color="#783e93"
        )
        .teasers(v-if="loading")
            .teaser.skeleton(v-for="teaser in teasers", :key="teaser.id", :style="style")
                .image
                .text
        .paginated-teasers(v-else)
            .teasers
                .teaser(v-for="teaser in teasers", :key="teaser.id", :style="style")
                    Teaser(:teaser="teaser", display="card")
                // .teaser.skeleton(:style="style")
                //     .image
                //     .text
            Pagination(
                v-if="pageInfo && pageInfo.lastPage > 1",
                :last-page="pageInfo.lastPage",
                :current-page="pageInfo.currentPage",
                nav-class="pagination is-rounded is-centered",
                @change="changePage"
            )
                span.icon(slot="prev")
                    font-awesome-icon(icon="arrow-left")
                span.icon(slot="next")
                    font-awesome-icon(icon="arrow-right")
    .vertical(v-else ref="teasers")
        .column.is-offset-1.is-10
            loading(
                :active="loading",
                :is-full-page="false",
                :height="40",
                :width="40",
                color="#95c021"
            )
            .teasers(v-if="loading")
                .teaser.skeleton(v-for="teaser in teasers", :key="teaser.id")
                    .image
                    .text
            .paginated-teasers(v-else)
                .teasers
                    .teaser(v-for="teaser in teasers", :key="teaser.id")
                        Teaser(:teaser="teaser", display="row")
                    // .teaser.skeleton
                    //     .image
                    //     .text
            Pagination(
                v-if="pageInfo && pageInfo.lastPage > 1",
                :last-page="pageInfo.lastPage",
                :current-page="pageInfo.currentPage",
                nav-class="pagination is-rounded",
                @change="changePage"
            )
                span.icon(slot="prev")
                    font-awesome-icon(icon="arrow-left")
                span.icon(slot="next")
                    font-awesome-icon(icon="arrow-right")
</template>

<script>
import router from '@/router';
import get from 'lodash.get'
import findIndex from 'lodash.findindex'
import cloneDeep from 'lodash.clonedeep';

import { mapGetters, mapMutations, mapActions } from 'vuex'

import Loading from 'vue-loading-overlay'
import Teaser from './Teaser'
import Select from './Partials/Select'

import Pagination from '@/components/Pagination'

export default {
    name: 'CategoryPosts',
    props: {
        section: {
            type: Object,
            required: true,
        },
        // perPage: {
        //     type: Number,
        //     default: 12,
        // },
        orientation: {
            type: String,
            default: 'vertical',
        }
    },
    data: () => {
        return {
            loading: false,
            currentPage: 1,
            pages: undefined,
            selectedFilter: {}
        }
    },
    components: {
        Loading,
        Teaser,
        Pagination,
        Select
    },
    computed: {
        s() {
            return findIndex(this.sections, { id: this.section.id })
        },
        // loading() {
        //     return get(this.section, 'teasers.loading', true)
        // },
        teasers() {
            let teasers = []
            teasers = get(this.pages, 'items') || [];
            return teasers;
        },
        filters() {
            return get(this.pages, 'teasers.pagination.filters')
        },
        pageInfo() {
            return get(this.pages, 'pageInfo')
        },
        style() {
            return {
                width: `calc(${100 / 4}% - 20px)`
            }
        },
        settings() {
            return get( this.section, 'settings', [] )
        },
        showFilter() {
            let value = false;
            if ( this.settings ) {
                let filter = this.settings.find( setting => setting.key === 'show_filter' );
                if ( filter && filter.value && filter.value === 'true' ) value = true;
            }
            return value;
        },
        sort() {
            // default value
            let sort = { direction: 'desc', field: 'created_at' };

            const settings = get(this.section, 'settings') || [];
            const sortOrder = settings.find(setting => setting.key === 'sort_order') || {
                direction: 'desc',
                field: 'created_at'
            };
            switch (sortOrder.value) {
                case 'date_desc':
                    sort = { direction: 'desc', field: 'created_at' };
                    break;
                case 'date_asc':
                    sort = { direction: 'asc', field: 'created_at' };
                    break;
                case 'title_desc':
                    sort = { direction: 'desc', field: 'title' };
                    break;
                case 'title_asc':
                    sort = { direction: 'asc', field: 'title' };
                    break;
                default:
                    sort = { direction: 'desc', field: 'created_at' };
                    break;
            }

            return sort;
        },
        perPage() {
            let perPage = 12;
            if (this.section && this.section.settings) {
                const setting = this.section.settings.find(setting => setting.key === 'rows');
                if (setting && setting.value !== undefined) perPage = parseInt(setting.value) * 4;
            }

            return perPage;
        },
        ...mapGetters({
            sections: 'currentPage/sections',
            cms: 'currentPage/CMS',
            categoryFilters: 'categoryFilters'
        })
    },
    methods: {
        updateCategoryFilter(payload) {
            if ( payload && payload.value && payload.value !== null && payload.value.length > 0 ) {
                if (Array.isArray(payload.value)) this.selectedFilter[payload.key] = payload.value.join();
                else this.selectedFilter[payload.key] = payload.value;
                 
            }else if ( this.selectedFilter[payload.key] ) delete this.selectedFilter[payload.key]
            this.refetch()
        },
        changePage(currentPage) {
            if ( this.$refs.teasers ) {
                this.$refs.teasers.scrollIntoView({
                    behavior: 'smooth'
                })
            }
            if ( currentPage > 1) {
                let query = {};
                query[`P${this.section.id}`] = currentPage;
                router.push({ query });
            }else router.push({ query: null });

            this.currentPage = currentPage;
            this.refetch();
        },
        refetch() {
            this.loading = true;
            let payload = {
                pageInfo: {
                    currentPage: parseInt(this.currentPage),
                    perPage: parseInt(this.perPage)
                },
                filters: [
                    {
                        key: 'section-selection',
                        match: this.section.id
                    },
                ],
                order: this.sort.field,
                direction: this.sort.direction
            };
            let payload2 = {
                pageInfo: {
                    currentPage: parseInt(this.currentPage),
                    perPage: parseInt(this.perPage)
                },
                filters: [
                    {
                        key: 'section-selection',
                        match: this.section.id
                    },
                    {
                        key: 'in_json',
                        in_json: JSON.stringify(this.selectedFilter)
                    }
                ],
                order: this.sort.field,
                direction: this.sort.direction
            };
            // in_json: '{\"alter\": \"20\",\"groesse\": \"170\"}'
            if(Object.keys(this.selectedFilter).length != 0) payload = payload2;
            this.fetchTeasers(payload)
                .then( response => {
                    if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
                        this.changePage(response.pageInfo.lastPage);
                        return;
                    }
                    const pages = cloneDeep(response);
                    if (pages.items && pages.items.length) {
                        pages.items.forEach( (page, i) => {
                            page.position = i + 1;
                        });
                    }

                    this.pages = pages;
                })
                .finally(() => {
                    this.loading = false;
                })

        },
        /*load(page = 1) {
            // console.log('load');
            this.fetching = true;

            let pagination = get(this.section, 'teasers.pagination')

            if (! pagination) {

                const categories = this.section.categories.map(category => category.id)
                const tags = this.section.tags.map(tag => tag.id)

                pagination = {
                    filters: [
                        { key: 'categories', in: categories },
                        { key: 'tags', in: tags },
                        { key: 'cms', match: store.getters.CMS.id }
                    ],
                    pageInfo: {
                        currentPage: 1,
                        lastPage: 1,
                        total: 0,
                        perPage: this.perPage
                    },
                }
            }

            pagination.pageInfo.currentPage = page

            this.fetchTeasers(pagination)
                .then(({ items, pageInfo }) => {
                    let filters = cloneDeep(pagination.filters);
                    const teasers = {
                        loading: false,
                        pagination: { filters, items, pageInfo }
                    };
                    this.insertTeasers({ s: this.s, teasers });
                })
                .finally(() => (this.fetching = false));
        },*/
        ...mapMutations('currentPage', {
            updateTeasersLoading: 'updateCategoryPostTeasersLoading',
            insertTeasers: 'insertTeasers',
        }),
        ...mapActions('currentPage', {
            fetchTeasers: 'fetchCategoryPostTeasers',
        }),
    },
    mounted() {
        // this.load();
        const pages = { loading: true, pagination: {} };
        this.pages = pages;

        this.currentPage = get( this.$route, `query.P${this.section.id}` ) || 1;
        this.refetch();
    }
}
</script>

<style lang="scss" scoped>

    @import '~bulma/sass/utilities/mixins';
    @import '~@/assets/sass/variables';
    @import '~empty-state/skeleton';

    $topicColor: #E4B6FA;
    .subfilter {
        margin: 15px auto;
        padding: 25px 0;
        border-top: 3px solid $primary;
        border-bottom: 3px solid $primary;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        @include mobile {
            flex-direction: column;
            align-items: center;
        } 
        .custom-select {
            margin: 0 10px;
            @include mobile {
                margin: 10px 0;
                width: 90%;
            }
            &:last-child {
                margin: 0;
                margin-left: 10px;
                @include mobile {
                    margin-top: 10px;
                    margin-bottom: 10px;
                    margin-left: 0;
                }
            }
            &:first-child {
                margin: 0;
                margin-right: 10px;
                @include mobile {
                    margin-top: 10px;
                    margin-bottom: 10px;
                    margin-right: 0;
                }
            }
        } 
    }
    .category-posts{
        margin-top: 35px
    }
    .category-posts ::v-deep .pagination-container {
        margin-top: 20px;
        .pagination {
            .pagination-previous,
            .pagination-next {
                padding-left: 0.3em;
                padding-right: 0.3em;
            }
            .pagination-previous {
                @include mobile {
                    order: 1;
                }
            }
            .pagination-list {
                @include mobile {
                    order: 2;
                }
            }
            .pagination-next {
                @include mobile {
                    order: 3;
                }
            }
        }
    }

    .category-posts .vertical ::v-deep .pagination-container {
        margin-top: 50px;
    }

    .horizontal {
        .teasers {
            text-align: center;
            .teaser {
                margin-bottom: 50px;
                display: inline-block;
                &:last-child {
                    margin-bottom: 10px;
                }
                @include mobile {
                    width: 100% !important;
                    max-width: 360px;
                }

                &.skeleton {
                    .image {
                        padding-bottom: 57%; // ca. 9 / 16
                        background: $skeletonColor;
                        border-radius: 3px;
                    }
                    .text {
                        // $imageHeight: 140px;
                        $imageHeight: 0px;
                        $margin: 20px;
                        $topicHeight: 12px;
                        $headingHeight: 22px;
                        $headingGutter: 6px;
                        $teaserHeight: 12px;
                        $teaserGutter: 4px;

                        $headingLines: 2;
                        $teaserLines: 5;

                        $headingY: $imageHeight + $margin + $topicHeight + $margin;
                        $teaserY: $headingY + $headingLines * ($headingHeight + $headingGutter) - $headingGutter + $margin;

                        $height: $teaserY + $teaserLines * ($teaserHeight + $teaserGutter) - $teaserGutter;

                        $shapes: (
                            // rect(#D8D8D8, 100%, $imageHeight, 0, 0),
                            rect($topicColor, 140px, $topicHeight, 0, $imageHeight + $margin),
                        );

                        $shapes: join($shapes, lines($headingLines, $skeletonColor, 100%, $headingHeight, $headingGutter, 0, $headingY, 60%));
                        $shapes: join($shapes, lines($teaserLines, $skeletonColor, 100%, $teaserHeight, $teaserGutter, 0, $teaserY, 30%));
                        @include skeleton($shapes...);

                        height: $height;
                    }
                }
            }
            @include tablet {
                margin: -10px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                flex-wrap: wrap;
                .teaser {
                    margin:  10px;
                    margin-bottom: 10px;
                    flex-grow: 0;
                    flex-shrink: 0;
                }
            }
        }
    }

    .vertical {
        .teasers {
            text-align: center;
            .teaser {
                margin-bottom: 50px;
                &:last-child {
                    margin-bottom: 10px;
                }
                @include mobile {
                    width: 100% !important;
                    max-width: 360px;
                    display: inline-block;
                }
                &.skeleton {
                    .image {
                        padding-bottom: 57%; // ca. 9 / 16
                        background: $skeletonColor;
                        border-radius: 3px;
                        margin-bottom: 20px;
                        @include tablet {
                            padding-bottom: initial;
                            margin-bottom: 0;
                            height: 180px;
                            width: 320px;
                            flex-basis: 320px;
                            flex-grow: 0;
                            flex-shrink: 0;
                        }
                    }
                    .text {
                        $margin: 20px;
                        $topicHeight: 12px;
                        $headingHeight: 22px;
                        $headingGutter: 6px;
                        $teaserHeight: 12px;
                        $teaserGutter: 4px;

                        $headingLines: 2;
                        $teaserLines: 5;

                        $headingY: $topicHeight + $margin;
                        $teaserY: $headingY + $headingLines * ($headingHeight + $headingGutter) - $headingGutter + $margin;

                        $height: $teaserY + $teaserLines * ($teaserHeight + $teaserGutter) - $teaserGutter;

                        $shapes: (
                            // rect(#D8D8D8, 100%, $imageHeight, 0, 0),
                            rect($topicColor, 140px, $topicHeight, 0, 0),
                        );

                        $shapes: join($shapes, lines($headingLines, $skeletonColor, 100%, $headingHeight, $headingGutter, 0, $headingY, 60%));
                        $shapes: join($shapes, lines($teaserLines, $skeletonColor, 100%, $teaserHeight, $teaserGutter, 0, $teaserY, 30%));
                        @include skeleton($shapes...);

                        height: $height;

                        @include tablet {
                            flex-grow: 1;
                            margin-left: 20px;
                        }
                    }
                    @include tablet {
                        display: flex;
                        flex-direction: row;
                    }
                }
            }
        }
    }

</style>